export const SET_EXERCICE = "SET_EXERCICE";

// annee : année de début de l'exercice (2026 pour 2026/2027)
export function setExercice(annee) {
  return {
    type: SET_EXERCICE,
    annee,
  };
}

// Vrai si l'exercice n'a pas changé depuis l'envoi d'une requête filtrée par année :
// une réponse arrivée après un changement d'exercice ne doit pas écraser le store du nouvel exercice.
export const isExerciceCourant = (getState, annee) => getState().exercice.annee === annee;
